import { createStyles, makeStyles, useTheme } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { CustomTheme } from "../../../../../../types/customTheme";
import "chartjs-adapter-moment";
import g_line_1 from "../../../../../../assets/images/g_line_1.png";
import g_line_2 from "../../../../../../assets/images/g_line_2.png";
import g_line_3 from "../../../../../../assets/images/g_line_3.png";
import g_line_4 from "../../../../../../assets/images/g_line_4.png";
import g_line_5 from "../../../../../../assets/images/g_line_5.png";
import g_line_1_light_mode from "../../../../../../assets/images/g_line_1_light_mode.png";
import g_line_2_light_mode from "../../../../../../assets/images/g_line_2_light_mode.png";
import g_line_3_light_mode from "../../../../../../assets/images/g_line_3_light_mode.png";
import g_line_4_light_mode from "../../../../../../assets/images/g_line_4_light_mode.png";
import g_line_5_light_mode from "../../../../../../assets/images/g_line_5_light_mode.png";
import g_line_deliveroo from "../../../../../../assets/images/g_line_deliveroo.png";
import g_line_eatpresto from "../../../../../../assets/images/g_line_eatpresto.png";
import g_line_justeat from "../../../../../../assets/images/g_line_justeat.png";
import g_line_ubereats from "../../../../../../assets/images/g_line_ubereats.png";
import g_line_deliveroo_light_mode from "../../../../../../assets/images/g_line_deliveroo_light_mode.png";
import g_line_eatpresto_light_mode from "../../../../../../assets/images/g_line_eatpresto_light_mode.png";
import g_line_justeat_light_mode from "../../../../../../assets/images/g_line_justeat_light_mode.png";
import g_line_ubereats_light_mode from "../../../../../../assets/images/g_line_ubereats_light_mode.png";
import {
  Chart as ChartJS,
  TimeScale, //Import timescale instead of category for X axis
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Watermark } from "@hirohe/react-watermark";
import { getLocalStore } from "../../../../../../utils/store/localStore";

ChartJS.register(
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const useStyles = makeStyles<any>((theme: CustomTheme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.entity_background,
    },
    color: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

export interface DashboardProps {
  data: any;
  dateDifference: any;
  dataSetLength: any;
  setDataIndex: any;
  isEmpty?: any;
  currentStartDate: any;
  currentEndDate: any;
  order: any;
  isChannel: any;
  value: any;
}

const Chart: React.FunctionComponent<DashboardProps> = ({
  data,
  dateDifference,
  dataSetLength,
  setDataIndex,
  isEmpty,
  currentStartDate,
  currentEndDate,
  order,
  isChannel,
  value,
}) => {
  const classes = useStyles();
  const theme: CustomTheme = useTheme();

  const handleChartBackgroundColorCurrentPeriod = (key: string) => {
    // theme.palette.background[`g_line_${index + 1}`]
    if (
      key === " Total Amount" ||
      key === " Orders Count" ||
      key === " Average Amount" ||
      key === " Cash Payments" ||
      key === " Walk In"
    ) {
      return theme.palette.background[`g_line_1`];
    } else if (key === " Card Payments") {
      return theme.palette.background[`g_line_2`];
    } else if (key === " Other Payments") {
      return theme.palette.background[`g_line_3`];
    } else if (key === " Walk In") {
      return theme.palette.background[`g_line_1`];
    } else if (key === " Online") {
      return theme.palette.background[`g_line_2`];
    } else if (key === " Kiosk") {
      return theme.palette.background[`g_line_3`];
    } else if (key === " Phone") {
      return theme.palette.background[`g_line_4`];
    } else if (key === "  Walk In") {
      return theme.palette.background[`g_line_1`];
    } else if (key === " Dine In") {
      return theme.palette.background[`g_line_2`];
    } else if (key === " Delivery") {
      return theme.palette.background[`g_line_3`];
    } else if (key === " Collection") {
      return theme.palette.background[`g_line_4`];
    } else if (key === " Future Table") {
      return theme.palette.background[`g_line_5`];
    } else {
      return theme.palette.background[`g_line_1`];
    }
  };

  const handleChartBackgroundColorPreviousPeriod = (key: string) => {
    if (
      key === " Total Amount" ||
      key === " Orders Count" ||
      key === " Average Amount" ||
      key === " Cash Payments" ||
      key === " Walk In"
    ) {
      if (value === "line") {
        return theme.palette.background[`g_line_lighter_6`];
      } else {
        return theme.palette.background[`g_line_lighter_1`];
      }
    } else if (key === "orders count") {
      if (value === "line") {
        return theme.palette.background[`g_line_lighter_6`];
      } else {
        return theme.palette.background[`g_line_lighter_1`];
      }
    } else if (key === "  Card Payments") {
      return theme.palette.background[`g_line_lighter_2`];
    } else if (key === "  Other Payments") {
      return theme.palette.background[`g_line_lighter_3`];
    } else if (key === " Walk In") {
      if (value === "line") {
        return theme.palette.background[`g_line_lighter_6`];
      } else {
        return theme.palette.background[`g_line_lighter_1`];
      }
    } else if (key === " Online") {
      return theme.palette.background[`g_line_lighter_2`];
    } else if (key === " Kiosk") {
      return theme.palette.background[`g_line_lighter_3`];
    } else if (key === " Phone") {
      return theme.palette.background[`g_line_lighter_4`];
    } else if (key === " Walk In") {
      if (value === "line") {
        return theme.palette.background[`g_line_lighter_6`];
      } else {
        return theme.palette.background[`g_line_lighter_1`];
      }
    } else if (key === " Dine In") {
      return theme.palette.background[`g_line_lighter_2`];
    } else if (key === " Ddelivery") {
      return theme.palette.background[`g_line_lighter_3`];
    } else if (key === " Collection") {
      return theme.palette.background[`g_line_lighter_4`];
    } else if (key === " Future Table") {
      return theme.palette.background[`g_line_lighter_5`];
    } else {
      if (value === "line") {
        return theme.palette.background[`g_line_lighter_6`];
      } else {
        return theme.palette.background[`g_line_lighter_1`];
      }
    }
  };

  const handleChannelBorderColor = (channelName: string) => {
    if (channelName === " Eatpresto") {
      return "#CF5B6A";
    }
    if (channelName === " Justeat") {
      return "#F08F3A";
    }
    if (channelName === " Deliveroo") {
      return "#00b3b3";
    }
    if (channelName === "Ubereats") {
      return "#3A9D76";
    }
  };
  const isDarkMode = getLocalStore("isDarkMode");
  let img: any = {};
  img["eatpresto"] = new Image();
  img["eatpresto"].src = g_line_eatpresto;
  img["eatpresto"].height = 8;
  img["eatpresto"].width = 12;

  img["justeat"] = new Image();
  img["justeat"].src = g_line_justeat;
  img["justeat"].height = 8;
  img["justeat"].width = 12;

  img["deliveroo"] = new Image();
  img["deliveroo"].src = g_line_deliveroo;
  img["deliveroo"].height = 8;
  img["deliveroo"].width = 12;

  img["ubereats"] = new Image();
  img["ubereats"].src = g_line_ubereats;
  img["ubereats"].height = 8;
  img["ubereats"].width = 12;

  img["eatpresto_light_mode"] = new Image();
  img["eatpresto_light_mode"].src = g_line_eatpresto_light_mode;
  img["eatpresto_light_mode"].height = 8;
  img["eatpresto_light_mode"].width = 12;

  img["justeat_light_mode"] = new Image();
  img["justeat_light_mode"].src = g_line_justeat_light_mode;
  img["justeat_light_mode"].height = 8;
  img["justeat_light_mode"].width = 12;

  img["deliveroo_light_mode"] = new Image();
  img["deliveroo_light_mode"].src = g_line_deliveroo_light_mode;
  img["deliveroo_light_mode"].height = 8;
  img["deliveroo_light_mode"].width = 12;

  img["ubereats_light_mode"] = new Image();
  img["ubereats_light_mode"].src = g_line_ubereats_light_mode;
  img["ubereats_light_mode"].height = 8;
  img["ubereats_light_mode"].width = 12;

  img["1_light_mode"] = new Image();
  img["1_light_mode"].src = g_line_1_light_mode;
  img["1_light_mode"].height = 8;
  img["1_light_mode"].width = 12;

  img["2_light_mode"] = new Image();
  img["2_light_mode"].src = g_line_2_light_mode;
  img["2_light_mode"].height = 8;
  img["2_light_mode"].width = 12;

  img["3_light_mode"] = new Image();
  img["3_light_mode"].src = g_line_3_light_mode;
  img["3_light_mode"].height = 8;
  img["3_light_mode"].width = 12;

  img["4_light_mode"] = new Image();
  img["4_light_mode"].src = g_line_4_light_mode;
  img["4_light_mode"].height = 8;
  img["4_light_mode"].width = 12;

  img["5_light_mode"] = new Image();
  img["5_light_mode"].src = g_line_5_light_mode;
  img["5_light_mode"].height = 8;
  img["5_light_mode"].width = 12;

  img["6_light_mode"] = new Image();
  img["6_light_mode"].src = g_line_1_light_mode;
  img["6_light_mode"].height = 8;
  img["6_light_mode"].width = 12;

  img["1"] = new Image();
  img["1"].src = g_line_1;
  img["1"].height = 8;
  img["1"].width = 12;

  img["2"] = new Image();
  img["2"].src = g_line_2;
  img["2"].height = 8;
  img["2"].width = 12;

  img["3"] = new Image();
  img["3"].src = g_line_3;
  img["3"].height = 8;
  img["3"].width = 12;

  img["4"] = new Image();
  img["4"].src = g_line_4;
  img["4"].height = 8;
  img["4"].width = 12;

  img["5"] = new Image();
  img["5"].src = g_line_5;
  img["5"].height = 8;
  img["5"].width = 12;

  img["6"] = new Image();
  img["6"].src = g_line_1;
  img["6"].height = 8;
  img["6"].width = 12;

  const handleChannelBorderColorLighter = (channelName: string) => {
    if (isDarkMode === "true") {
      if (channelName === " Eatpresto") {
        return img["eatpresto"];
      }
      if (channelName === " Justeat") {
        return img["justeat"];
      }
      if (channelName === " Deliveroo") {
        return img["deliveroo"];
      }
      if (channelName === " Ubereats") {
        return img["ubereats"];
      }
    } else {
      if (channelName === " Eatpresto") {
        return img["eatpresto_light_mode"];
      }
      if (channelName === " Justeat") {
        return img["justeat_light_mode"];
      }
      if (channelName === " Deliveroo") {
        return img["deliveroo_light_mode"];
      }
      if (channelName === " Ubereats") {
        return img["ubereats_light_mode"];
      }
    }
  };

  const handleChannelLighter = (key: any, channelName: any) => {
    if (isDarkMode === "true") {
      if (
        key === " Total Amount" ||
        key === " Orders Count" ||
        key === " Average Amount" ||
        key === " Cash Payments" ||
        key === " Walk In"
      ) {
        return img[1];
      } else if (key === " Card Payments") {
        return img[2];
      } else if (key === " Other Payments") {
        return img[3];
      } else if (key === " Phone") {
        return img[4];
      } else if (key === " Kiosk") {
        return img[3];
      } else if (key === " Online") {
        return img[2];
      } else if (key === " Collection") {
        return img[4];
      } else if (key === " Delivery") {
        return img[3];
      } else if (key === " Dine In") {
        return img[2];
      } else if (key === " Future Table") {
        return img[5];
      } else {
        return img[1];
      }
    } else {
      if (
        key === " Total Amount" ||
        key === " Orders Count" ||
        key === " Average Amount" ||
        key === " Cash Payments" ||
        key === " Walk In"
      ) {
        return img["1_light_mode"];
      } else if (key === " Card Payments") {
        return img["2_light_mode"];
      } else if (key === " Other Payments") {
        return img["3_light_mode"];
      } else if (key === " Phone") {
        return img["4_light_mode"];
      } else if (key === " Kiosk") {
        return img["3_light_mode"];
      } else if (key === " Online") {
        return img["2_light_mode"];
      } else if (key === " Collection") {
        return img["4_light_mode"];
      } else if (key === " Delivery") {
        return img["3_light_mode"];
      } else if (key === " Dine In") {
        return img["2_light_mode"];
      } else if (key === " Future Table") {
        return img["5_light_mode"];
      } else {
        return img["1_light_mode"];
      }
    }
  };

  /* Change the tooltip label using the x-axis of the chart. */
  const handleTooltipLabelDateFormat = (label: any) => {
    if (label === "12 AM") {
      return "12:00 AM";
    } else {
      // Input = 1 AM Output 1:00 AM
      return moment(label, "HH").format("hh:mm A");
    }
  };

  /* Change the chart UI after select date range */
  const optionsOneDateRange: any = {
    maintainAspectRatio: false,
    elements: {
      line: {
        // line width
        tension: 0.5,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      xAxes: {
        type: "time",
        time: {
          displayFormats: {
            day: "YYYY-MM-DD",
          },
          unit: "day",
        },
        ticks: {
          // Change the font size in the weekend dates.
          font: (c: any) => {
            return (
              (moment(c.tick.Date).day() === 6 ||
                moment(c.tick.Date).day() === 0) && { weight: "600" }
            );
          },
          // Change the font color in the weekend dates.
          color: (c: any) => {
            return moment(c.tick.Date).day() === 6 ||
              moment(c.tick.Date).day() === 0
              ? theme.palette.background.g_line_3
              : theme.palette.custom.orange.contrastText;
          },
          callback: function (label: any, index: any, labels: any) {
            labels[index].Date = label;
            return moment(label).format("Do");
          },
        },
        grid: {
          display: false,
        },
      },
      yAxes: {
        beginAtZero: true,
        suggestedMax: 100,
        ticks: {
          beginAtZero: false,
          max: 0,
          min: -0.5,
          color: theme.palette.custom.orange.contrastText,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      title: {
        display: false,
      },
      tooltip: {
        usePointStyle: true,
        callbacks: {
          labelPointStyle: (context: any) => {
            // A line will show the current Period.
            if (context.dataset.label === "Current Period") {
              return {
                pointStyle: "line",
                rotation: 0,
                radius: 5,
              };
            } else {
              // A dotted line will show the current Period.
              return {
                pointStyle: isChannel
                  ? handleChannelBorderColorLighter(context.dataset.key)
                  : handleChannelLighter(
                      context.dataset.key,
                      context.datasetIndex - dataSetLength + 1,
                    ),
                rotation: 0,
              };
            }
          },
          title: (context: any) => {
            return "";
          },
          labelColor: (context: any) => {
            // Change the label color in the previous period
            if (isChannel) {
              if (dataSetLength > context.datasetIndex) {
                return {
                  borderColor: handleChannelBorderColor(context.dataset.key),
                  backgroundColor: handleChannelBorderColor(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              } else {
                // Change the label color in the current period
                return {
                  borderColor: handleChannelBorderColorLighter(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChannelBorderColorLighter(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              }
            } else {
              if (dataSetLength > context.datasetIndex) {
                return {
                  borderColor: handleChartBackgroundColorCurrentPeriod(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChartBackgroundColorCurrentPeriod(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              } else {
                // Change the label color in the current period
                return {
                  borderColor: handleChartBackgroundColorPreviousPeriod(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChartBackgroundColorPreviousPeriod(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              }
            }
          },
          textDirection: "ltr",
          // Change the tooltip description
          label: (context: any) => {
            setDataIndex(context.dataIndex);
            // Change tool tip description from previous periods
            if (context.dataset.label === "Previous Period") {
              // To display the value without a decimal format for an order.
              if (order) {
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  moment(context.label)
                    .subtract(dateDifference, "d")
                    .format("ll") +
                  "   " +
                  context.formattedValue.replace(",", "")
                );
              } else {
                // To display the value with a decimal format for an other tooltips.
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  moment(context.label)
                    .subtract(dateDifference, "d")
                    .format("ll") +
                  "   " +
                  parseFloat(context.formattedValue.replace(",", "")).toFixed(2)
                );
              }
            } else {
              // To display the value without a decimal format for an order.
              if (order) {
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  moment(context.label).format("ll") +
                  "   " +
                  context.formattedValue.replace(",", "")
                );
              } else {
                // To display the value with a decimal format for an other tooltips.
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  moment(context.label).format("ll") +
                  "   " +
                  parseFloat(context.formattedValue.replace(",", "")).toFixed(2)
                );
              }
            }
          },
        },
      },
      legend: {
        position: "bottom",
        labels: {
          // Show chart details in the footer.
          generateLabels: function (chart: any) {
            const data = chart.data;
            const legends = Array.isArray(data.datasets)
              ? data.datasets.map(function (dataset: any, i: any) {
                  return {
                    text:
                      dataset.label === "Previous Period"
                        ? `${dataset.key.replace("Payments", "")} (Previous)`
                        : `${dataset.key.replace("Payments", "")} (Current)`,
                    fillStyle:
                      dataset.label === "Previous Period"
                        ? theme.palette.background.entity_background
                        : dataset.borderColor,
                    hidden: !chart.isDatasetVisible(i),
                    fontColor: theme.palette.custom.orange.contrastText,
                    lineDash: dataset.borderDash,
                    lineWidth: dataset.borderWidth,
                    strokeStyle: dataset.borderColor,
                    fill: dataset.fill,
                    datasetIndex: i,
                  };
                }, this)
              : [];
            return legends;
          },
          boxWidth: 35,
          boxHeight: 6,
          padding: 32,
          font: {
            weight: "bold",
          },
        },
      },
    },
  };

  /* Change the chart UI after select one date */
  const dateOptions: any = {
    maintainAspectRatio: false,
    elements: {
      line: {
        // line width
        tension: 0.5,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      xAxes: {
        ticks: {
          color: theme.palette.custom.orange.contrastText,
        },
        grid: {
          display: false,
        },
      },
      yAxes: {
        beginAtZero: true,
        suggestedMax: 100,
        ticks: {
          color: theme.palette.custom.orange.contrastText,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      title: {
        display: false,
      },
      tooltip: {
        usePointStyle: true,
        multiKeyBackground: theme.palette.background.g_line_1,
        callbacks: {
          labelPointStyle: (context: any) => {
            // A line will show the current Period.
            if (context.dataset.label === "Current Period") {
              return {
                pointStyle: "line",
                rotation: 0,
                radius: 5,
              };
            } else {
              // A dotted line will show the current Period.
              return {
                rotation: 0,
                pointStyle: isChannel
                  ? handleChannelBorderColorLighter(context.dataset.key)
                  : handleChannelLighter(
                      context.dataset.key,
                      context.datasetIndex - dataSetLength + 1,
                    ),
              };
            }
          },
          title: (context: any) => {
            return "";
          },
          labelColor: (context: any) => {
            // Change the label color in the previous period
            if (isChannel) {
              if (dataSetLength > context.datasetIndex) {
                return {
                  borderColor: handleChannelBorderColor(context.dataset.key),
                  backgroundColor: handleChannelBorderColor(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              } else {
                // Change the label color in the current period
                return {
                  borderColor: handleChannelBorderColorLighter(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChannelBorderColorLighter(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              }
            } else {
              if (dataSetLength > context.datasetIndex) {
                return {
                  borderColor: handleChartBackgroundColorCurrentPeriod(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChartBackgroundColorCurrentPeriod(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              } else {
                // Change the label color in the current period
                return {
                  borderColor: handleChartBackgroundColorPreviousPeriod(
                    context.dataset.key,
                  ),
                  backgroundColor: handleChartBackgroundColorPreviousPeriod(
                    context.dataset.key,
                  ),
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.background.entity_border}`,
                };
              }
            }
          },
          textDirection: "ltr",
          // Change the tooltip description
          label: (context: any) => {
            setDataIndex(context.dataIndex);
            // Change tool tip description from previous periods
            if (context.dataset.label === "Previous Period") {
              // To display the value without a decimal format for an order.
              if (order) {
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  handleTooltipLabelDateFormat(context.label) +
                  "   " +
                  context.formattedValue.replace(",", "")
                );
              } else {
                // To display the value with a decimal format for an other tooltips.
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  handleTooltipLabelDateFormat(context.label) +
                  "   " +
                  parseFloat(context.formattedValue.replace(",", "")).toFixed(2)
                );
              }
            } else {
              // To display the value without a decimal format for an order.
              if (order) {
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  handleTooltipLabelDateFormat(context.label) +
                  "   " +
                  context.formattedValue.replace(",", "")
                );
              } else {
                // To display the value with a decimal format for an other tooltips.
                return (
                  "  " +
                  context.dataset.key +
                  "   " +
                  handleTooltipLabelDateFormat(context.label) +
                  "   " +
                  parseFloat(context.formattedValue.replace(",", "")).toFixed(2)
                );
              }
            }
          },
        },
      },
      legend: {
        position: "bottom",
        labels: {
          // Show chart details in the footer.
          generateLabels: function (chart: any) {
            const data = chart.data;
            const legends = Array.isArray(data.datasets)
              ? data.datasets.map(function (dataset: any, i: any) {
                  return {
                    text: dataset.key,
                    fillStyle:
                      dataset.label === "Previous Period"
                        ? theme.palette.background.entity_background
                        : dataset.borderColor,
                    hidden: !chart.isDatasetVisible(i),
                    fontColor: theme.palette.custom.orange.contrastText,
                    lineDash: dataset.borderDash,
                    lineWidth: dataset.borderWidth,
                    strokeStyle: dataset.borderColor,
                    datasetIndex: i,
                  };
                }, this)
              : [];
            return legends;
          },
          boxWidth: 35,
          boxHeight: 6,
          padding: 32,
          font: {
            weight: "bold",
          },
        },
      },
    },
  };
  return (
    <>
      <div
        className={classes.root}
        style={{ height: "350px" }}
        onMouseOut={() => {
          setDataIndex("");
        }}
      >
        {isEmpty ? (
          <Watermark
            lineHeight="1.2rem"
            opacity={0.2}
            rotate={-45}
            show
            text={"Sample Data"}
            textColor={theme.palette.custom.orange.contrastText}
            textSize={24}
            gutter={50}
            wrapperElement="div"
          >
            {" "}
            <div style={{ height: "350px" }}>
              <Line
                style={{ margin: "16px 16px 0px 16px", height: "350px" }}
                options={
                  currentStartDate === currentEndDate
                    ? dateOptions
                    : optionsOneDateRange
                }
                data={data}
              ></Line>
            </div>
          </Watermark>
        ) : (
          <Line
            style={{ margin: "16px 16px 0px 16px", height: "350px" }}
            options={
              currentStartDate === currentEndDate
                ? dateOptions
                : optionsOneDateRange
            }
            data={data}
          ></Line>
        )}
      </div>
    </>
  );
};

export default Chart;
